module.exports = __webpack_public_path__ + "static/media/Road-pin.32c1bc89.png";